
<template>
    <div class="container">
        <div class="top_content">
            <div class="list van-hairline--bottom">
                <div class="right_title">商家名称</div>
                <div class="left_content">{{ information.name }}</div>
            </div>
            <div class="list van-hairline--bottom">
                <div class="right_title">商家电话</div>
                <div class="left_content">
                    <a
                        v-for="(item, index) in phoneList"
                        :key="index"
                        :href="'tel:' + item">
                        <span @click="dialPhone(item)">{{ item + ";" }}</span>
                    </a>
                </div>
            </div>
            <div class="list van-hairline--bottom">
                <div class="right_title">商家地址</div>
                <div class="left_content">{{ information.address }}</div>
            </div>
            <div class="list van-hairline--bottom">
                <div class="right_title ">商家简介</div>
                <div class="left_content ellipsis" >{{ information.desc ? information.desc : "暂无简介" }}</div>
            </div>
        </div>
        <div class="bottom_pic">
            <div class="list">
                <div class="right_title">相关资质</div>
            </div>
            <div class="qualification">
                <div class="qualification_top" @click="seeImg(item)"   v-for="(item, index) in imgList1" :key="index">
                    <img alt="营业执照" :src="imgPrex + item + '?x-image-process=style/watermark-thumbnail'" />
                     <!-- '?x-image-process=style/watermark-thumbnail' 图片加水印 -->
                </div>
                <div class="qualification_bottom" @click="seeImg(item)"   v-for="(item, index) in imgList2" :key="index">
                    <img alt="资质图片" :src="imgPrex + item + '?x-image-process=style/watermark-thumbnail'" />
                    <!-- <img alt="营业执照" :src="imgPrex + item" /> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getSellerInfo } from "@/api/join";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      information: "",
      phoneList: [],
      imgList1: [],
      imgList2: []
    };
  },
  mounted() {
    this.getSellerInfo();
  },
  methods: {
    seeImg(item) {
      ImagePreview([this.imgPrex + item + '?x-image-process=style/watermark-thumbnail']);
    },
    dialPhone(phone) {
      console.log(phone);
      window.Android.dialPhone(phone);
    },
    getSellerInfo() {
      //请求数据
      getSellerInfo({
        sellerId: this.GetQueryString("sellerId") //
      }).then(res => {
        if (res.appStatus.errorCode == 0) {
          this.information = res.content;
          this.imgList1 = this.information.businessLicenseImage
            ? this.information.businessLicenseImage.split(",")
            : [];
          this.imgList2 = this.information.zzImage
            ? this.information.zzImage.split(",")
            : [];
          this.phoneList = this.information.phone
            ? this.information.phone.split(",")
            : [];
          console.log(this.phoneList);
          console.log(this.imgList1);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.top_content {
  padding: 0 12px;
  .list {
    display: flex;
    font-size: 14px;
    padding: 15px 0 15px 0;
    .right_title {
      flex: 2;
      color: #999999;
    }
    .left_content {
      flex: 8;
      color: #333333;
      margin-left: 19px;
    }
    .ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
.bottom_pic {
  padding: 0 12px;
  .list {
    height: 19px;
    font-size: 14px;
    padding: 15px 0 15px 0;
    .right_title {
      display: inline-block;
      color: #999999;
    }
  }
  .qualification {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .qualification_top {
      padding: 0 10px 10px 0;
      width: 160px;
      height: 133px;
    }
    .qualification_bottom {
      padding: 0 10px 10px 0;
      width: 150px;
      height: 133px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>